'use client'

import { Globe } from 'lucide-react'
import { useTranslation } from '@/lib/i18n'
import { LOCALE_LABELS, type Locale } from '@/lib/i18n/types'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export function LanguageSwitcher() {
  const { locale, setLocale } = useTranslation()

  return (
    <DropdownMenu>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="h-7 w-7"
                aria-label="Switch language"
              >
                <Globe className="h-4 w-4" />
                <span className="sr-only">Switch language</span>
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>Switch language</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DropdownMenuContent align="center" side="top">
        {(Object.entries(LOCALE_LABELS) as [Locale, string][]).map(([code, label]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLocale(code)}
            className={locale === code ? 'bg-accent font-semibold' : ''}
          >
            <span className="mr-2 text-base">{getFlagEmoji(code)}</span>
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

function getFlagEmoji(locale: Locale): string {
  switch (locale) {
    case 'en': return 'EN'
    case 'ar': return 'AR'
    case 'fr': return 'FR'
    case 'hi': return 'HI'
    default: return ''
  }
}
